const columns = [
  {
    field: 'Model',
    headerName: '型号',
    editable: false,
    minWidth: 150
  },
  {
    field: 'Brand',
    headerName: '品牌',
    editable: false
  },
  {
    field: 'Packaging',
    headerName: '封装',
    editable: false
  },
  {
    field: 'MakeYear',
    headerName: '批号',
    editable: false
  },
  {
    field: 'InvQty',
    headerName: '库存数量',
    editable: false
  },
  {
    field: 'MaxViewQty',
    headerName: '最大展示量',
    editable: false
  },

  {
    field: 'IsWholePackage',
    headerName: '整包出售',
    editable: false,
    width: 90
  },
  {
    field: 'MPQQty',
    headerName: 'MPQ',
    width: 80
  },
  {
    field: 'UntaxedPrice',
    headerName: '未税价',
    minWidth: 100,
    cellRenderer(params) {
      return params.value ? `¥${params.value}` : '--';
    }
  },
  {
    field: 'TaxRate',
    headerName: '是否可开票',
    // editable: false,
    minWidth: 98,
    dataMap: [
      { key: 13, value: '可开票 13%' },
      { key: 3, value: '可开票 3%' },
      { key: 0, value: '不可开票' }
    ],
    cellStyle() {
      return {
        textAlign: 'left'
      };
    }
  },
  {
    field: 'StepPlanGuid',
    headerName: '阶梯价方案',
    editable: false,
    minWidth: 86
  },
  {
    field: 'SettlementPrice',
    headerName: '结算价',
    minWidth: 100,
    editable: false
  },

  {
    field: 'Stauts',
    headerName: '状态',
    editable: false,
    width: 100
  }
];

export { columns };
